import React, { useEffect, useState } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

import { paths } from 'routes';

import { Search } from 'components/Search';
import { BreadCrumbs } from 'components/Breadcrumbs';
import { ContentLayout } from 'components/Layout';
import { Pagination } from 'components/Pagination';

// import { Add } from '../components/Add';
import { useAuth } from 'lib/auth';
import { OrderByDropdown } from 'components/Filter/Inputs/OrderByDropdown';
import { Loader } from 'components/Loader';
import { NotFound } from 'components/NotFound/NotFound';
import { Add } from '../components/Add';
import { ListItem } from '../components/ListItem';
import { useGetAll } from '../api/getAll';
import { PaperCard } from 'components/Card';
import { CheckboxFilter } from 'components/Filter/Inputs/CheckboxFilter';

export const List = () => {
  const { account, user } = useAuth();
  const [page, setPage] = useState(1);
  // const [search, setSearch] = useState('');
  const [filters, setFilters] = useState({
    includeInactive: false,
    sortBy: !account.super_admin && user.Company.subscription_level === 'free' ? 'dateCreated' : sessionStorage.getItem('blogs_sortBy') || 'dateCreated',
  });

  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);

  const {
    data: { blogs, total },
    refetch: refetchBlogs,
    isFetching,
  } = useGetAll({
    ...filters,
    page: page - 1,
    queryOptions: {
      onSettled: () => {
        clearTimeout(timer);
        setTimeout(() => setLoading(false), 1000);
      }
    },
  });

  // const debouncedSearchChange = useDebouncedCallback((search) => setSearch(search), 300);
  // const handleSearchChange = ({ target: { value: search } }) => {
  //   debouncedSearchChange(search);
  // };

  // const handleFilterUpdate = ({ target: { name, value, checked } }) => {
  //   setFilters((filters) => {
  //     switch (name) {
  //       case 'sortBy':
  //         sessionStorage.setItem('blogs_sortBy', value);
  //         return { ...filters, [name]: value };

  //       default:
  //         return { ...filters, [name]: checked };
  //     }
  //   });
  // };

  const handleFilterUpdate = ({ target: { name, checked } }) => {
    setFilters((filters) => {
      return { ...filters, [name]: checked };
    });
  };

  const handlePageChange = (_, page) => setPage(page);  

  useRefetch();
  
  const caption = account.super_admin ? 'Click the "Add Blog" button to begin' : '';

  useEffect(() => {
    if (isFetching) {
      const timeoutId = setTimeout(() => setLoading(true), 500);
      setTimer(timeoutId);
    } else {
      clearTimeout(timer);
    }

    return () => clearTimeout(timer);
  }, [isFetching]);

  return (
    <ContentLayout>
      <Stack height={1}>
        <Stack>
          <BreadCrumbs
            items={[
              { name: '', to: paths.blog },
              { name: `Blog${total > 0 ? ` (${total})` : ''}` },
            ]}
          />
        </Stack>
        <Stack>
          
        </Stack>

        <Stack
          px={4}
          py={2}
          bgcolor="background.paper"
          borderTop="1px solid"
          borderColor="border.main"
          height="100%"
        >
          <Stack direction="row" gap={2} alignItems="center" justifyContent={"end"}>
            {/* <Search handleSearchChange={handleSearchChange} sx={{ minWidth: 200, width: 270 }} /> */}

            {/* <OrderByDropdown
              name="sortBy"
              onChange={handleFilterUpdate}
              selected={filters.sortBy}
              options={[
                { value: 'dateCreated', text: 'Date Created' },
              ]}
            /> */}
            <Stack direction="row" gap={2} sx={{ flex: '1' }}>
              <CheckboxFilter
                adminOnly
                name="includeInactive"
                onChange={handleFilterUpdate}
                checked={filters.includeInactive}
                label="Inactive"
              />
            </Stack>
            {(account.super_admin || user.Company?.Type === 'buyer' || user.Company?.Type === 'supplier') && (
              <Add refetch={refetchBlogs} />
            )}
          </Stack>

          {isFetching && !loading ? 
          (
            <></>
          ) :
          (!isFetching || (isFetching && loading)) ?
          (
            <>
            {loading && (
              <Loader />
            )}
          
            {!loading && (
            <>
            {!blogs && (
              <Stack
                height="100%"
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography variant="h5">No Blog posts Added</Typography>
                {account.super_admin && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'text.secondary',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                      letterSpacing: '-0.14px',
                    }}
                  >
                    Click the "Add Blog" button to begin
                  </Typography>
                )}
              </Stack>
            )}

            {blogs && (
              <>
                <Stack
                  flex={1}
                  mt={2}
                  py={2}
                  bgcolor="background.paper"
                  borderTop="1px solid"
                  borderColor="border.main"
                  gap={1}
                >
                  {/* {blogs.length === 0 && (
                    <NotFound
                      wrapperSx={{ height: 1, justifyContent: "center" }}
                      title="No Blogs found"
                      caption={caption}
                    />
                  )} */}
                  {/* {blogs.length !== 0 &&
                    blogs.map((item) => (
                      <ListItem key={item.blog_id} {...item} />
                    ))
                  } */}
                  {blogs.length > 0 ? (
                    <Stack direction="column" gap={2}>
                      {blogs
                        .reduce((rows, item, index) => {
                          if (index % 3 === 0) {
                            rows.push([]);
                          }
                          rows[rows.length - 1].push(<ListItem key={item.blog_id} {...item} />);
                          return rows;
                        }, [])
                        .map((row, rowIndex, allRows) => {
                          const itemsInRow = row.length;
                          const emptySlotsNeeded = 3 - itemsInRow;
            
                          return (
                            <Stack key={rowIndex} direction="row" gap={2}>
                              {row.map((item) => item)}
                              {rowIndex === allRows.length - 1 && emptySlotsNeeded > 0 && (
                                Array.from({ length: emptySlotsNeeded }).map((_, index) => (
                                  <PaperCard
                                    sx={{
                                      flex: 1,
                                      boxShadow: 0,
                                      borderRadius: 1,
                                      p: 2,
                                      visibility: "hidden"
                                    }}
                                    key={`empty-${rowIndex}-${index}`}
                                    flex={1}
                                  >
                                    <></>
                                  </PaperCard>
                                ))
                              )}
                            </Stack>
                          );
                        })}
                    </Stack>
                  ) : (
                    <NotFound
                      wrapperSx={{ height: 1, justifyContent: "center" }}
                      title="No Blog posts found"
                      caption={caption}
                    />
                  )}
                </Stack>
              </>
            )}

            <Stack direction="row" justifyContent="center">
              <Pagination page={page} handlePageChange={handlePageChange} itemCount={total} itemsPerPage={6} />
            </Stack>
            </>
            )}
            </>
          ) :
          (
            <></>
          )}
        </Stack>
      </Stack>
    </ContentLayout>
  );

  function useRefetch() {
    useEffect(() => {     
      refetchBlogs();
    }, [page, filters]);
  }
};
